(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('CartController', CartController);

    /** @ngInject */
    function CartController($scope, $rootScope, $q, $timeout, $filter, $state, sweetAlert, ProductService, HelperService, ProviderService, AuthenticationService, ShippingCompanyService, OrderService, DATA_EVENTS) {
        const vm = this;
        let authSelectedUnit;

        vm.getProductImage = product => {
            return HelperService.imageHandlerPath('product', product.Id, product.Image);
        }

        vm.getProductStock = product => {
            let stock = false;

            if (ProductService.isNetSuiteProduct(product))
                stock = product.StockAvailable;

            return stock;
        }

        vm.cartTotal = () => {
            return ProductService.getProductsTotal(vm.cartProducts);
        }

        vm.cartAmount = () => {
            return ProductService.getProductsCount(vm.cartProducts);
        }

        vm.providerHasProducts = provider => {
            return provider && provider.Products && provider.Products.length;
        }

        vm.getProviderProducts = provider => {
            return vm.cartProducts.filter(prod => prod.ProviderId == provider.Id);
        }

        // Checkout
        vm.checkoutOrder = () => {
            // Verify if shipping companies and payment conditions they are filled
            let isValid = true;

            vm.units.map(unit => {
                unit.Providers.map(provider => {
                    if (provider.IsSynthetic) {
                        return;
                    }

                    if (!provider.SelectedShippingType) {
                        HelperService.setErrorMessageForm(`.shipping-type-${unit.Id}-${provider.Id}`, 'Este campo é obrigatório', false);
                        isValid = false;
                    }

                    if (!provider.SelectedShippingCompany) {
                        HelperService.setErrorMessageForm(`.shipping-company-${unit.Id}-${provider.Id}`, 'Este campo é obrigatório', false);
                        isValid = false;
                    }

                    if (!provider.SelectedPaymentCondition) {
                        HelperService.setErrorMessageForm(`.payment-condition-${unit.Id}-${provider.Id}`, 'Este campo é obrigatório', false);
                        isValid = false;
                    }

                    const providerValue = (provider.Products || []).reduce((acc, cur) => {
                        return acc + (cur.Value * cur.Amount);
                    }, 0);

                    // Verify the provider minimum value
                    if (providerValue < provider.MinimumValue) {
                        const minimumValue = $filter('currency')(provider.MinimumValue, 'R$', 2);

                        sweetAlert.swal({
                            title: 'Pedido inválido!',
                            text: `O pedido mínimo do fornecedor ${provider.Title} é de ${minimumValue}`,
                            type: 'error',
                            confirmButtonText: 'Voltar as compras',
                            showCancelButton: true,
                            cancelButtonText: 'Fechar',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then(response => {
                            if (response.value)
                                $state.go('app.products');
                        });

                        isValid = false;
                    }
                });
            });

            if (!isValid) return;

            HelperService.startLoading('.cart-holder');

            vm.isCheckouting = true;

            const userId = AuthenticationService.getUserId();

            let orderData = {
                PersonId: userId,
                FinalValue: vm.cartTotal(),
                Order_Product: []
            };

            vm.units.map(unit => {
                unit.Providers.map(provider => {
                    if (provider.IsSynthetic) {
                        return;
                    }

                    provider.Products.map(product => {
                        const orderProduct = orderData.Order_Product.find(orderProduct => (
                            orderProduct.UnitId == product.UnitId &&
                            orderProduct.ProductValueId == product.ProductValueId
                        ));

                        if (product && !orderProduct) {
                            orderData.Order_Product.push({
                                UnitId: product.UnitId,
                                ProductValueId: product.ProductValueId,
                                Quantity: product.Amount,
                                PaymentConditionId: provider.SelectedPaymentCondition.PaymentCondition.Id,
                                ShippingCompanyId: provider.SelectedShippingCompany.Id,
                                OrderStatusId: 1
                            });
                        }
                    });
                });
            });

            OrderService
                .post(orderData)
                .then(success => {
                    $rootScope.orderId = success.Id;
                    $rootScope.orderWarningMessages = angular.isArray(success.WarningMessages) ? success.WarningMessages : [];
                    ProductService.clearProducts();
                    vm.isCheckouting = false;

                    $timeout(() => {
                        $state.go('app.order-finalization');
                        HelperService.stopLoading('.cart-holder');
                    });
                }, error => errorCallback(error));
        }

        vm.updateProduct = product => {
            $timeout(() => {
                ProductService.updateProductAmount(product.UnitId, product.ProviderId, product.Id, product.Amount);
            });
        }

        vm.deleteProduct = (unitId, providerId, product) => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação é irreversível!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.cart-holder');

                    ProductService.removeProduct(unitId, providerId, product);

                    getCart();
                    setUnitsAndProviders();

                    HelperService.stopLoading('.cart-holder');
                }
            })
        }

        vm.onChangeUnit = () => {
            const currentSelectedUnit = AuthenticationService.getSelectedUnit();

            if (vm.selectedUnit.Id && vm.selectedUnit.Id != currentSelectedUnit.Id) {
                AuthenticationService
                    .setUnit(vm.selectedUnit.Id)
                    .then(response => {
                        $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                        // AuthenticationService.configureUserPermissions($state.current);

                        console.log('response: ', response);
                        if (response.error)
                            HelperService.handleStateChangeError(response);
                    }, error => {
                        console.log('error: ', error);
                        $rootScope.$broadcast(DATA_EVENTS.SELECTED_UNIT_CHANGE);

                        // AuthenticationService.configureUserPermissions($state.current);

                        HelperService.handleStateChangeError(error);
                    })
            }
        }

        vm.onSelectShippingType = (unit, provider) => {
            $rootScope.removeMessage(`.shipping-type-${unit.Id}-${provider.Id}`);

            HelperService.startLoading('.cart-holder');

            return ShippingCompanyService
                .getAllByType(provider.SelectedShippingType.Id)
                .then(success => {
                    vm.shippingCompanies = success;

                    if (vm.shippingCompanies.length == 1)
                        provider.SelectedShippingCompany = vm.shippingCompanies[0];
                    else
                        provider.SelectedShippingCompany = null;

                    applySystemKitCheckoutDefaults(provider);

                    HelperService.stopLoading('.cart-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.cart-holder');
                })
        }

        vm.onSelectShippingCompany = (unit, provider) => {
            $rootScope.removeMessage(`.shipping-company-${unit.Id}-${provider.Id}`);
            applySystemKitCheckoutDefaults(provider);
        }

        let removeWatchCartProducts = $scope.$watch('vm.units', () => {
            if (!vm.units)
                return;

            for (let index = 0; index < vm.cartProducts.length; index++) {
                let cartProduct = vm.cartProducts[index];

                for (let index = 0; index < vm.units.length; index++) {
                    const unit = vm.units[index];

                    for (let index = 0; index < unit.Providers.length; index++) {
                        const provider = unit.Providers[index];

                        let product = provider.Products.find(product => (cartProduct.Id == product.Id && cartProduct.UnitId == product.UnitId));

                        if (product && cartProduct.Amount != product.Amount) {
                            cartProduct.Amount = product.Amount;

                            ProductService.updateProductAmount(product.UnitId, product.ProviderId, product.Id, product.Amount);
                        }
                    }
                }
            }
        }, true)

        $scope.$on('$destroy', () => {
            removeWatchCartProducts();
        })

        init();

        function getCart() {
            vm.cartProducts = ProductService.getProducts();
        }

        function setUnitsAndProviders() {
            const units = AuthenticationService.getUnits();

            vm.units = units.filter(unit => vm.cartProducts.find(prod => prod.UnitId == unit.Id))
                .reduce((acc, cur) => {
                    const unitProducts = vm.cartProducts.filter(prod => prod.UnitId == cur.Id);
                    const catalogProviders = vm.providers.filter(prov => unitProducts.find(prod => prod.ProviderId == prov.Id));
                    const syntheticProviders = buildSyntheticProviders(unitProducts);

                    acc.push({
                        Id: cur.Id,
                        FantasyName: cur.FantasyName,
                        Providers: catalogProviders
                            .reduce((provAcc, provCur) => {
                                const provider = angular.copy(provCur);

                                provider.Products = unitProducts.filter(prod => prod.ProviderId == provCur.Id);
                                provider.SubTotal = provider.Products.reduce((total, product) => total += product.Value * product.Amount, 0);
                                provider.IsSynthetic = false;

                                provAcc.push(provider);

                                return provAcc;
                            }, [])
                            .concat(syntheticProviders)
                    });

                    return acc;
                }, []);
        }

        function buildSyntheticProviders(products) {
            return products
                .filter(product => !vm.providers.find(provider => provider.Id == product.ProviderId))
                .reduce((acc, product) => {
                    let syntheticProvider = acc.find(provider => provider.Id == product.ProviderId);

                    if (!syntheticProvider) {
                        syntheticProvider = {
                            Id: product.ProviderId,
                            Title: (product.Provider && product.Provider.Title) || 'Kit Inicial',
                            MinimumValue: 0,
                            Products: [],
                            Provider_PaymentCondition: [],
                            IsSynthetic: true
                        };

                        acc.push(syntheticProvider);
                    }

                    syntheticProvider.Products.push(product);
                    syntheticProvider.SubTotal = syntheticProvider.Products.reduce((total, currentProduct) => {
                        return total + (currentProduct.Value * currentProduct.Amount);
                    }, 0);

                    return acc;
                }, []);
        }

        function getProviders() {
            return ProviderService
                .getAll()
                .then(
                    success => vm.providers = success,
                    error => HelperService.errorCallback(error))
        }

        function getShippingTypes() {
            return ShippingCompanyService
                .getAllShippingTypes()
                .then(
                    success => vm.shippingTypes = success,
                    error => HelperService.errorCallback(error))
        }

        function errorCallback(error) {
            vm.isCheckouting = false;

            HelperService.errorCallback(error);
            HelperService.stopLoading('.cart-holder');
        }

        function normalizeText(value) {
            return (value || '').toString().trim().toUpperCase();
        }

        function isSystemProvider(provider) {
            const providerTitle = normalizeText(provider && provider.Title);
            return providerTitle == 'ML SYSTEM' || providerTitle == 'ML SYSTEMA';
        }

        function applySystemKitCheckoutDefaults(provider) {
            if (!provider || provider.IsSynthetic || !isSystemProvider(provider) || !provider.SelectedShippingType) {
                return;
            }

            const shippingTypeName = normalizeText(provider.SelectedShippingType.Title);
            const isClienteRetira = shippingTypeName.indexOf('CLIENTE RETIRA') >= 0;
            const isCorreios = shippingTypeName.indexOf('CORREIOS') >= 0;

            if (!isClienteRetira && !isCorreios) {
                return;
            }

            if (isCorreios && angular.isArray(vm.shippingCompanies) && vm.shippingCompanies.length) {
                const correiosCompany = vm.shippingCompanies.find(company => {
                    const companyName = normalizeText(company && company.Name);
                    return companyName.indexOf('EMPRESA BRASILEIRA DE CORREIOS') >= 0;
                });

                if (correiosCompany) {
                    provider.SelectedShippingCompany = correiosCompany;
                }
            }

            if (!angular.isArray(provider.Provider_PaymentCondition) || !provider.Provider_PaymentCondition.length) {
                return;
            }

            const prazoFornecedor = provider.Provider_PaymentCondition.find(item => {
                const paymentConditionName = normalizeText(item && item.PaymentCondition && item.PaymentCondition.Name);
                return paymentConditionName.indexOf('PRAZO FORNECEDOR') >= 0;
            });

            if (prazoFornecedor) {
                provider.SelectedPaymentCondition = prazoFornecedor;
            }
        }

        function init() {
            $rootScope.addDivisor = true;

            vm.isLoading = true;
            vm.providers = [];

            vm.unitName = AuthenticationService.getSelectedUnit().FantasyName;
            authSelectedUnit = AuthenticationService.getSelectedUnit();

            const units = AuthenticationService.getUnits();
            let foundUnit = units.find(unit => (unit.Id == authSelectedUnit.Id));

            if (foundUnit)
                vm.selectedUnit = foundUnit;

            HelperService.startLoading('.cart-holder');

            $q.all([getCart(), getProviders(), getShippingTypes()])
                .then(() => {
                    setUnitsAndProviders();
                    HelperService.stopLoading('.cart-holder');
                })
        }
    }
}());
